import * as Tgcc from './tgccGlobal';
import { TgccApp } from './tgccmain';

export type reducerAction = {
    type: string;
    payload: any;
}

const newState = (state : Tgcc.GlobalState, changes : any) => {
    return Object.assign({}, state, changes);
}

export const reducer = (state : Tgcc.GlobalState, action : reducerAction) => {
    switch (action.type) {
        case Tgcc.StateAction.LocalUserDataLoaded:
            return newState(state, { UserInfo: action.payload['UserInfo'], LoginData: action.payload['LoginData']});
        case Tgcc.StateAction.SetEditState:
            return newState(state, { EditState: action.payload as Tgcc.EditStates });
        case Tgcc.StateAction.UpdateProofProduct:
            state.ActiveProof.product = action.payload as Tgcc.Product;
            return newState(state, {
                EditState: Tgcc.EditStates.None,
                ActiveProof: state.ActiveProof,
                ForwardLocation: Tgcc.Routes.ProofEdit
            });
        case Tgcc.StateAction.ProofFromMerch:
            var mb = action.payload as Tgcc.MerchBinding;
            var merchProof: Tgcc.Proof = new Tgcc.Proof;
            merchProof.product = mb.product;
            merchProof.design = mb.design;
            var merchandising = mb.merchandising;
            merchProof.text.front = merchandising.frontDesignText;
            merchProof.frontLocation = merchandising.frontDesignPosition;
            merchProof.text.back = merchandising.backDesignText;
            merchProof.backLocation = merchandising.backDesignPosition;
            merchProof.embroidery = merchandising.embroidery;
            merchProof.screenPrint = !merchProof.embroidery;
            merchProof.smsAllowed = true;
            merchProof.phone = "";

            return newState(state, {
                EditState: Tgcc.EditStates.None,
                ActiveProof: merchProof,
                ForwardLocation: mb.editRoute
            });
        case Tgcc.StateAction.DesignFromReal:
                var design = action.payload as Tgcc.Design;
                var proof: Tgcc.Proof = new Tgcc.Proof;
                proof.design = design;  
                return newState(state, {
                    EditState: Tgcc.EditStates.None,
                    ActiveProof: proof,
                    ForwardLocation: Tgcc.Routes.CampusProofEdit
                });
        case Tgcc.StateAction.DesignFromRealCampus:
                    var design = action.payload as Tgcc.Design;
                    var proof: Tgcc.Proof = new Tgcc.Proof;
                    proof.design = design;  
                    return newState(state, {
                        EditState: Tgcc.EditStates.None,
                        ActiveProof: proof,
                        ForwardLocation: Tgcc.Routes.RealCampusProofEdit
                    });
        case Tgcc.StateAction.UpdateIndigoProofProduct:
            state.ActiveProof.product = action.payload as Tgcc.Product;
            return newState(state, {
                EditState: Tgcc.EditStates.None,
                ActiveProof: state.ActiveProof,
                ForwardLocation: Tgcc.Routes.IndigoProofEdit
            });  
        case Tgcc.StateAction.UpdateCampusProofProduct:
            state.ActiveProof.product = action.payload as Tgcc.Product;
            return newState(state, {
                EditState: Tgcc.EditStates.None,
                ActiveProof: state.ActiveProof,
                ForwardLocation: Tgcc.Routes.CampusProofEdit
            });          
         case Tgcc.StateAction.UpdateRealCampusProofProduct:
                state.ActiveProof.product = action.payload as Tgcc.Product;
                return newState(state, {
                    EditState: Tgcc.EditStates.None,
                    ActiveProof: state.ActiveProof,
                    ForwardLocation: Tgcc.Routes.RealCampusProofEdit
                });
        case Tgcc.StateAction.UpdateProofDesign:
            var proof: Tgcc.Proof = state.ActiveProof;
            proof.design = action.payload as Tgcc.Design;

            return newState(state , {
                EditState: Tgcc.EditStates.None,
                ActiveProof: proof,
                ForwardLocation: Tgcc.Routes.ProofEdit
            })

        case Tgcc.StateAction.UpdateProofDesignWithoutNav:
            return {
                ...state,
                ActiveProof: {
                ...state.ActiveProof,
                design: {
                    id: action.payload.id,
                    rawImage: action.payload.rawImage,
                    previewImage: action.payload.previewImage,
                }
                }
            };
        
        case Tgcc.StateAction.UpdateRealCampusProofDesign:
                var proof: Tgcc.Proof = state.ActiveProof;
                proof.design = action.payload as Tgcc.Design;
    
                return newState(state , {
                    EditState: Tgcc.EditStates.None,
                    ActiveProof: proof,
                    ForwardLocation: Tgcc.Routes.RealCampusProofEdit
                })
         case Tgcc.StateAction.UpdateCampusProofDesign:
            var proof: Tgcc.Proof = state.ActiveProof;
            proof.design = action.payload as Tgcc.Design;

            return newState(state , {
                EditState: Tgcc.EditStates.None,
                ActiveProof: proof,
                ForwardLocation: Tgcc.Routes.CampusProofEdit
            });

        case Tgcc.StateAction.UpdateIndigoProofDesign:
            var proof: Tgcc.Proof = state.ActiveProof;
            proof.design = action.payload as Tgcc.Design;

            return newState(state , {
                EditState: Tgcc.EditStates.None,
                ActiveProof: proof,
                ForwardLocation: Tgcc.Routes.IndigoProofEdit
            })
        case Tgcc.StateAction.UpdateCatalogDesigns:
                var proof: Tgcc.Proof = state.ActiveProof;
                proof.notes += action.payload as string + "\n";
                return newState(state , {
                    EditState: Tgcc.EditStates.None,
                    ActiveProof: proof,
                    ForwardLocation: Tgcc.Routes.Catalog
                })
        case Tgcc.StateAction.SetSelectedProductForDesign:
            const updatedProof = { ...state.ActiveProof, product: action.payload };
            return newState(state, { ActiveProof: updatedProof });
                
        case Tgcc.StateAction.UpdateProofNotes:
            return {
                ...state,
                ActiveProof: {
                    ...state.ActiveProof,
                    notes: action.payload,
                },
            };
        
        case Tgcc.StateAction.UpdateInHandsDate:
        // Assuming you are passing the inHandsDate as a string in the payload
            return {
                ...state,
                ActiveProof: {
                ...state.ActiveProof,
                inHandsDate: action.payload,
                },
            };

        case Tgcc.StateAction.SetActiveProof:
            return {
                ...state,
                ActiveProof: {
                    ...new Tgcc.Proof(), // Reset to default proof structure
                    ...action.payload, // Apply any new proof data passed in action.payload
                },
            };

        case Tgcc.StateAction.ResetActiveProof:
            return {
                ...state,
                ActiveProof: new Tgcc.Proof(), // Reset to default proof structure
            };

        case Tgcc.StateAction.UpdateEventName:
            if (state.ActiveProof) {
                return {
                ...state,
                ActiveProof: {
                    ...state.ActiveProof,
                    eventName: action.payload,
                },
                };
            }
            return state;
            
        case Tgcc.StateAction.UpdateProof:
            return {
                ...state,
                ActiveProof: {
                    ...state.ActiveProof,
                    ...action.payload,
                    apparelItems: action.payload.apparelItems ?? state.ActiveProof.apparelItems
                }
            };
        
            
        case Tgcc.StateAction.UpdateProofSalesContact:
                state.ActiveProof.salescontact = action.payload as string;
            return newState(state, {ActiveProof: state.ActiveProof});
        case Tgcc.StateAction.UpdateProofDivision:
                state.ActiveProof.division = action.payload as string;
            return newState(state, {ActiveProof: state.ActiveProof});
        case Tgcc.StateAction.FilterProductsByCategory:
            return newState(state, {FilterProductsByCategory: action.payload as string});
        case Tgcc.StateAction.FilterProductsBySearch:
            return newState(state, {FilterProductsBySearch: action.payload as string})
        case Tgcc.StateAction.FilterDesignsByCategory:
            return newState(state, {FilterDesignsByCategory: action.payload as string});
        case Tgcc.StateAction.FilterDesignsBySearch:
            return newState(state, {FilterDesignsBySearch: action.payload as string})
        case Tgcc.StateAction.FilterDesignsByLicense:
            return newState(state, {FilterDesignsByLicense: action.payload as Tgcc.License});
        case Tgcc.StateAction.SetBackLocation:
            state.ActiveProof.backLocation = action.payload as string;
            return newState(state, {ActiveProof: state.ActiveProof, EditState: Tgcc.EditStates.None})
        case Tgcc.StateAction.SetBackText:
            state.ActiveProof.text.back = action.payload as string;
            return newState(state, {ActiveProof: state.ActiveProof, EditState: Tgcc.EditStates.None});
        case Tgcc.StateAction.SetFrontLocation:
            state.ActiveProof.frontLocation = action.payload as string;
            return newState(state, {ActiveProof: state.ActiveProof, EditState: Tgcc.EditStates.None});
        case Tgcc.StateAction.SetFrontText:
            state.ActiveProof.text.front = action.payload as string;
            return newState(state, {ActiveProof: state.ActiveProof, EditState: Tgcc.EditStates.None});
        case Tgcc.StateAction.Login:
            return newState(state, {LoginData: action.payload as Tgcc.LoginData})
        case Tgcc.StateAction.Logout:
            return newState(state, {LoginData: null, UserInfo: new Tgcc.UserInfo, OrderHistory: null, ActiveOrders: null, ActiveProof: null});
        case Tgcc.StateAction.SetUserInfo:
            return newState(state, {UserInfo: action.payload as Tgcc.UserInfo})
        case Tgcc.StateAction.DialogAction:
            return newState(state, {DialogAction: action.payload as Tgcc.DialogActionType});
        case Tgcc.StateAction.SetPaymentType:
            return newState(state,{PaymentConfig: action.payload as Tgcc.PaymentConfig})
        case Tgcc.StateAction.ProofAndQuantitiesSubmitted:
            return {
                ...state,
                activeProof: action.payload.activeProof, // Assuming this payload contains the updated proof
                paymentConfig: action.payload.paymentConfig, // And the payment configuration
                quantities: action.payload.quantities, // Include submitted quantities
            };
        case Tgcc.StateAction.ProofPopup:
            var dAction = action.payload ? Tgcc.DialogAction.ProofPopup : null;
            return newState(state, {DialogAction: {action: dAction}, ProofPopup: action.payload as Tgcc.Proof});
        case Tgcc.StateAction.CampusProofPopup:
            var dAction = action.payload ? Tgcc.DialogAction.CampusProofPopup : null;
            return newState(state, {DialogAction: {action: dAction}, ProofPopup: action.payload as Tgcc.Proof});
        case Tgcc.StateAction.RealCampusProofPopup:
                var dAction = action.payload ? Tgcc.DialogAction.RealCampusProofPopup : null;
            return newState(state, {DialogAction: {action: dAction}, ProofPopup: action.payload as Tgcc.Proof});
        case Tgcc.StateAction.ForwardLocation:
            return newState(state,{ ForwardLocation: action.payload as string });
        case Tgcc.StateAction.ChangeProofFlags:
            var proof=state.ActiveProof;
            proof[action.payload['name']] = action.payload['value'];
            return newState(state, {ActiveProof: proof});
        case Tgcc.StateAction.Lead:
            state.didLead = action.payload
            return newState(state,{didLead:action.payload as boolean})
        // Set the current design selection (apparelIndex and designIndex)
        case Tgcc.StateAction.SetCurrentDesignSelection:
            return newState(state, {
                currentDesignSelection: action.payload as Tgcc.CurrentDesignSelection
            });

        // Set the selected design code
        case Tgcc.StateAction.UpdateSelectedDesignCode:
            return newState(state, {
                selectedDesignCode: action.payload as string
            });

        default:
            return state;
    }
}
